module.exports = __webpack_public_path__ + "media/images/logos/University-of-Malaya-5c5fb5b67233dca285493a46fa6970f2.svg";